<template>
    <div v-if="task && task.reworkReasonSummary" class="text-caption">
        <div>
            <b>Rework</b> - {{ task.reworkReasonSummary }}  <span v-if="task.reworkAdditional"
                                                                  class="text-medium-emphasis"
                                                                  @mouseenter="showAdditional = true"
                                                                  @mouseleave="showAdditional = false"><i>{{ reworkAdditional }}</i></span>
        </div>
        <v-btn v-if="taskItems.length > 0"
               @click="showItems = !showItems"
               size="x-small"
               variant="tonal"
               color="primary"
               class="my-1"
               :prepend-icon="showItems ? 'mdi-chevron-up' : 'mdi-chevron-down'">{{ showItems ? 'Hide' : 'Show items' }}</v-btn>
        <v-expand-transition>
            <div v-if="showItems">
                <v-table density="compact" class="text-caption task-item-table">
                    <tbody>
                        <tr>
                            <th class="text-left pa-1">Item</th>
                            <th class="text-right pa-1">Quantity</th>
                            <th class="text-right pa-1" v-if="nuwall">Picked</th>
                            <th class="text-right pa-1" v-if="nuwall">Strip</th>
                        </tr>
                        <tr v-for="taskItem in taskItems" :key="taskItem.jobItemId">
                            <td class="pa-1">{{ taskItem.itemDescription }}</td>
                            <td class="text-right pa-1">{{ taskItem.quantity }}</td>
                            <td class="text-right pa-1" v-if="nuwall">{{ taskItem.pickedQuantity }} <span v-if="taskItem.pickLength">({{taskItem.pickLength}}M)</span></td>
                            <td class="text-right pa-1" v-if="nuwall">{{ taskItem.stockStripQuantity }}</td>
                        </tr>
                    </tbody>
                </v-table>
            </div>
        </v-expand-transition>
    </div>
</template>
<style scoped>
    .task-item-table td, .task-item-table th {
        border: 1px solid rgb(var(--v-theme-primary)) !important;
        background-color: #E3F2FD !important;
    }
</style>
<script>
    export default {
        name: "JobTaskReworkSummary",
        data: function () {
            return {
                showItems: false,
                showAdditional: false
            };
        },
        props: {
            task: Object,
            nuwall: Boolean,
        },
        computed: {
            reworkAdditional() {
                const additional = this.task.reworkAdditional || '';
                // Only show the start of long comments until hovered
                if (!this.showAdditional && additional.length > 35) {
                    return additional.substring(0, 35) + '...';
                }
                return additional;
            },
            taskItems() {
                if (this.task && this.task.jobItemTasks) {
                    const items = [...this.task.jobItemTasks].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
                    // First line is usually the colour line - exclude from view
                    if (items.length > 0 && (items[0].itemDescription || '').startsWith('Colour')) {
                        items.shift();
                    }
                    return items;
                }
                return [];
            }
        }
    };
</script>
